import React, { Component } from 'react';
import * as Request from '../../service/data-info-chart/requestsUtil';
import edit from '../../resources/images/estrategas/tools/edit.svg';
import { Input, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';


class View extends Component {

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.editClaims = this.editClaims.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.state = { modal: false };
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  editClaims() {
    let params = {
      'claim': this.state.text,
      'date': this.props.date,
      'idBussines': this.props.place.id
    };
    Request.postFetch(this.props.url, params)
      .then(
        this.props.callbackFromParent(Math.random())
      );
    this.toggle();
  }

  handleChange(evt) {
    const target = evt.target;
    const name = target.name;
    const value = target.value;
    this.setState({ [name]: value });
  }

  render() {
    let classUser = this.props.authorization ? 'quality-edit' : 'quality-edit-unauthorized';
    return (
      <div>
        <div className={classUser}>
          <img src={edit} title="Editar" alt=" " onClick={this.toggle}/>
        </div>
        <Modal className='modal-large' isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader className='header-modal'
                       toggle={this.toggle}>Periodo {this.props.dateModal}</ModalHeader>
          <ModalBody>
            <div className='container'>
              <p className='container-fluid'>Reclamación {this.props.place.name}:</p>
              <Input placeholder="Ingrese el texto" type="textarea" name="text"
                     id={this.props.place.id}
                     value={this.state.text} onChange={this.handleChange}
                     style={{ height: '400px' }}/>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.editClaims}>Aceptar</Button>{' '}
            <Button color="danger" onClick={this.toggle}>Cancelar</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default View;



// WEBPACK FOOTER //
// ./src/components/buttons/saveModal.js